import React from 'react';

import styles from '../styles.module.scss';
import whiteListStyles from './WhiteList.module.scss';
import {WhiteList} from '../../../assets';

export const WhiteListCard = () => {
  return (
    <div className={whiteListStyles.whiteList}>
      <div className={styles.label}>
        <div className={styles.labelInner}>SECURITY</div>
      </div>
      <h4 className={styles.title}>Role-Based Control & IP Whitelisting</h4>
      <p className={styles.subTitle}>
        Take charge of your server's security with role-based control and IP whitelisting. Define
        access, limit permissions, and safeguard your dashboard with precision.
      </p>
      <div className={whiteListStyles.infoWrapper}>
        <WhiteList />
      </div>
    </div>
  );
};
